import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../shared-services/snack.service';
import { TiposEnvio } from './tiposEnvio.model';
import { BackendService } from '../core/backend.service';

@Injectable()
export class TiposEnvioResolver implements Resolve<TiposEnvio> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(TiposEnvio);
      }
      return await this.backendService.get(TiposEnvio, TiposEnvio.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/tiposEnvio']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tiposEnvio/tiposEnvio.resolver.ts